import MODES from '../constants/modes';

const MOBILE_MAX_WIDTH = 760;
const TABLET_MAX_WIDTH = 1200;

const getPreviewModeForDevice = (deviceMode) => {
  if (deviceMode) return deviceMode;

  const viewportWidth = window.innerWidth;

  if (viewportWidth < MOBILE_MAX_WIDTH) return MODES.mobile;
  if (viewportWidth < TABLET_MAX_WIDTH) return MODES.tablet;

  return MODES.desktop;
};

export default getPreviewModeForDevice;
